export var DATA_LAKE_CONFIG_ACTION = /* @__PURE__ */ ((DATA_LAKE_CONFIG_ACTION2) => {
  DATA_LAKE_CONFIG_ACTION2["Create"] = "create";
  DATA_LAKE_CONFIG_ACTION2["Update"] = "update";
  DATA_LAKE_CONFIG_ACTION2["Delete"] = "delete";
  return DATA_LAKE_CONFIG_ACTION2;
})(DATA_LAKE_CONFIG_ACTION || {});
export var JobStatus = /* @__PURE__ */ ((JobStatus2) => {
  JobStatus2["Cancelled"] = "cancelled";
  JobStatus2["Complete"] = "complete";
  JobStatus2["Error"] = "error";
  JobStatus2["Paused"] = "paused";
  JobStatus2["Runnable"] = "runnable";
  JobStatus2["Running"] = "running";
  return JobStatus2;
})(JobStatus || {});
export var JobType = /* @__PURE__ */ ((JobType2) => {
  JobType2["Restore"] = "restore";
  JobType2["Optimize"] = "optimize";
  JobType2["Delete"] = "delete";
  return JobType2;
})(JobType || {});
